import type { ReactNode } from 'react'
import { Dialog } from './Dialog.tsx'
import styles from './ConfirmDialog.module.css'

type Props = {
	open: boolean
	title: string
	body: ReactNode
	confirmLabel: string
	destructive?: boolean
	busy?: boolean
	onConfirm: () => void
	onClose: () => void
}

// Title, an explanation of what the action will do, and a confirm/cancel
// pair. `destructive` colours the confirm button; the body is the part that
// has to do the work of telling someone what they are about to change.
export const ConfirmDialog = ({
	open,
	title,
	body,
	confirmLabel,
	destructive = false,
	busy = false,
	onConfirm,
	onClose,
}: Props) => (
	<Dialog open={open} onClose={onClose}>
		<form
			className={styles.panel}
			onSubmit={(e) => {
				e.preventDefault()
				if (!busy) onConfirm()
			}}
		>
			<h2 className={styles.heading}>{title}</h2>
			<div className={styles.body}>{body}</div>
			<div className={styles.actions}>
				<button
					type="button"
					className={styles.secondary}
					onClick={onClose}
					disabled={busy}
				>
					Cancel
				</button>
				<button
					type="submit"
					className={
						destructive ? styles.destructive : styles.primary
					}
					disabled={busy}
				>
					{confirmLabel}
				</button>
			</div>
		</form>
	</Dialog>
)
